import React from 'react';
import { useSelector } from 'react-redux';

import { GPSRaw as GPSRawUI } from '@/components/ui/dashboard/Monitor';

const GPSRaw = ({ data: robotId }) => {
  const droneOsd = useSelector((state) => state.telemetry[robotId]?.droneOsd);

  return (
    <GPSRawUI
      latitude={droneOsd?.latitude ?? 0}
      longitude={droneOsd?.longitude ?? 0}
      altitude={droneOsd?.height ?? 0}
      satellites={droneOsd?.position_state?.gps_number ?? 0}
    />
  );
};

export default GPSRaw;
